export const getModifiedCatalogs = (arr) => {
    const res = arr?.map((e) => {
        let obj = {};
        // istanbul ignore else
        if (e?.tags && e?.tags?.length > 3) {
            const initial = 0;
            const s = e?.tags?.slice(3);
            const intialTags = e?.tags?.slice(0, 4);
            const sumWithInitial = intialTags.reduce((acc, current) => acc + current.length, initial);
            let tagsCount = 3;
            if (sumWithInitial < 30) {
                tagsCount = 5;
            }
            if ((sumWithInitial > 27 && sumWithInitial < 40) || e['reference-implementation-id'] === 'RI003O') {
                tagsCount = 3;
            }
            const tagsarr = e?.tags?.slice(0, tagsCount);
            obj = { ...e, shownumber: true, numbmsg: s?.length, tagsArr: tagsarr };
        } else {
            const s = e?.tags;
            obj = { ...e, shownumber: false, numbmsg: '0', tagsArr: s };
        }
        return obj;
    });

    return res;
};

export const searchInChild = (objects, toSearch) => {
    // eslint-disable-next-line no-underscore-dangle
    let _finded = false;
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < objects.length; i++) {
        // eslint-disable-next-line no-restricted-syntax
        for (const key in objects[i]) {
            if (objects[i][key] != null && typeof objects[i][key] !== 'boolean' && typeof objects[i][key] !== 'number') {
                if (typeof objects[i][key] === 'object') {
                    _finded = searchInChild(objects[i][key], toSearch);
                } else if (objects[i][key].toLowerCase().includes(toSearch.toLowerCase())) {
                    _finded = true;
                }
            }
        }
    }
    return _finded;
};
export const findNested = (objects, toSearch) => {
    // eslint-disable-next-line no-underscore-dangle
    const _results = [];
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < objects.length; i++) {
        // eslint-disable-next-line no-restricted-syntax
        for (const key in objects[i]) {
            if (objects[i][key] != null && typeof objects[i][key] !== 'boolean' && typeof objects[i][key] !== 'number') {
                if (typeof objects[i][key] === 'object') {
                    if (searchInChild(objects[i][key], toSearch)) {
                        _results.push(objects[i]);
                    }
                } else if (objects[i][key].toLowerCase().includes(toSearch.toLowerCase())) {
                    _results.push(objects[i]);
                }
            }
        }
    }
    return _results;
};
